import { Component, OnInit, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { CompanyView, QuickSearchCompaniesParameters } from '@api-proxies';
import { CompanyService } from '@http/clients/company.service';
import { GenericTypeAheadDropdownComponent, GenericTypeAheadMultiselectComponent } from 'ngx-lib';
import { CustomMenuItemComponent } from '../../custom-menu-item/custom-menu-item.component';
import { FormEditorBase, createValueAccessorProvider } from '../base/form-editor-base';

@Component({
    selector: 'app-companies-form-editor',
    templateUrl: './companies-form-editor.component.html',
    styleUrls: ['./companies-form-editor.component.scss'],
    providers: [createValueAccessorProvider(CompaniesFormEditorComponent)],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericTypeAheadMultiselectComponent, GenericTypeAheadDropdownComponent, CustomMenuItemComponent]
})
export class CompaniesFormEditorComponent extends FormEditorBase<CompanyView[]> implements OnInit {
    // Inputs for direct signal usage
    value = input<CompanyView[]>();
    readonly = input<boolean>(false);
    placeholderText = input<string>('Select Companies');
    multiple = input<boolean>(true);
    labelText = input<string>('Companies');

    private readonly companyService = inject(CompanyService);

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.loadCompanies();
    }

    selectedItem(): CompanyView | undefined {
        const items = this.selectedItems();
        return items && items.length > 0 ? items[0] : undefined;
    }

    onSelectedItemChange(item?: CompanyView): void {
        if (item) {
            this.onSelectedItemsChange([item]);
        } else {
            this.onSelectedItemsChange([]);
        }
    }

    protected override async onEntityTextChange(text: string): Promise<void> {
        if (!text) {
            this.items.set([]);
            return;
        }

        const companies = await this.companyService.search({
            filterText: text,
            organizationId: undefined,
            isActive: true
        } as QuickSearchCompaniesParameters);

        this.items.set(companies);
    }

    protected override mapSelectedItemsToValue(): CompanyView[] {
        return this.selectedItems() || [];
    }

    protected override mapValueToSelectedItems(value: CompanyView[]): any[] {
        return value || [];
    }

    private async loadCompanies(): Promise<void> {
        this.items.set([]);
    }
}
